export const config = {
    apiKey: "AIzaSyBOWZRS-a8i5E0oxDUtILIbxBQOuS7ARWA",
    authDomain: "quota-server.firebaseapp.com",
    databaseURL: "https://quota-server.firebaseio.com",
    projectId: "quota-server",
    storageBucket: "quota-server.appspot.com",
    messagingSenderId: "1050012276",
    appId: "1:1050012276:web:a2c2e41050a9f01894bf21",
    measurementId: "G-NR95MKBF5N"
};